const sameReceipts = (previous = [], next = []) => {
  if (!Array.isArray(previous) || !Array.isArray(next)) return false
  if (previous.length !== next.length) return false

  for (let i = 0; i < previous.length; i += 1) {
    const a = previous[i]
    const b = next[i]
    if (
      a?.id !== b?.id ||
      a?.receipt_no !== b?.receipt_no ||
      a?.receipt_date !== b?.receipt_date ||
      a?.amount !== b?.amount ||
      a?.updatedAt !== b?.updatedAt ||
      a?.voided !== b?.voided
    ) {
      return false
    }
  }

  return true
}

const receipts = (receipts = [], action) => {
  switch (action.type) {
    case 'FETCH_RECEIPTS':
      return sameReceipts(receipts, action.payload) ? receipts : action.payload
    default:
      return receipts
  }
}
export default receipts
